import { Injectable } from '@angular/core';
import { Session } from 'src/app/interface/session/session';
import { SessionCode } from 'src/app/enums/session/session-code.enum';
import { SessionKey } from 'src/app/enums/session/session-key.enum';

@Injectable({
  providedIn: 'root'
})
export class LanguageSession implements Session
{
    constructor() { }

    get(): string | SessionCode
    {
        try{
            const language = localStorage.getItem( SessionKey.LANGUAGE ) 
            return language ? language : SessionCode.MISSING_VALUE
        }catch(error)
        {
            return SessionCode.GENERIC
        }
    }

    set( language : string ): SessionCode
    {
        if(!language) return  SessionCode.INVALID_INPUT

        try{
            localStorage.setItem( SessionKey.LANGUAGE, language ) 
            return SessionCode.OK
        }catch(error)
        {
            return SessionCode.GENERIC
        }

    }

    clear(): SessionCode
    {
        try{
            localStorage.removeItem( SessionKey.LANGUAGE ) 
            return SessionCode.OK
        }catch(error)
        {
            return SessionCode.GENERIC
        }

    }
}

